module.exports = __webpack_public_path__ + "img/trash.092dc576.svg";